import React from 'react';

export const PublicReceiptFairness = ({ round }) => <dl className="keno-detail-list" data-testid="public-receipt-fairness">
  <dt>Committed server seed (SHA-256)</dt><dd data-testid="public-receipt-seed-hash">{round.server_seed_hash || 'No commitment recorded'}</dd>
  <dt>Nonce</dt><dd data-testid="public-receipt-nonce">{round.nonce ?? '—'}</dd>
</dl>;